export class AppError extends Error {
    constructor(
        public readonly name: string,
        public readonly originalError: unknown,
        message: string,
        public readonly details = originalError instanceof Error ? [originalError.message] : [],
        public readonly severity: 'WARN' | 'ERROR' = 'ERROR',
    ) {
        super(message);

        if (originalError instanceof Error && originalError.stack) {
            this.stack = originalError.stack;
        }
    }

    public toJSON(): Record<string, unknown> {
        return {
            name: this.name,
            message: this.message,
            originalError:
                this.originalError instanceof Error
                    ? {
                          message: this.originalError.message,
                          stack: this.originalError.stack,
                      }
                    : this.originalError,
        };
    }
}

export function appError(message: string, error?: unknown): AppError {
    return new AppError('AppError', error, message);
}

export function isAppError(err: unknown): err is AppError {
    return err instanceof AppError;
}
